module.exports = __webpack_public_path__ + "static/media/harshpurohit.89d2aed1.jfif";